import { isEmpty } from "@q4/nimbus-ui";
import { EntityBase } from "../../definitions/entity.definition";

export function handleSetEntity<T extends EntityBase>(entity: T, entities: T[], assignDefaultEntity: boolean): T {
  if (isEmpty(entities)) return entity;
  const hasEntity = !isEmpty(entity);
  const updated = hasEntity ? entities.find((x) => x._id === entity._id) : entity;
  return (hasEntity && !isEmpty(updated)) || !assignDefaultEntity ? updated : entities[0];
}
